export default __webpack_public_path__ + "static/media/6_bees.5be7b46a.png";